import Marquee from "react-fast-marquee";

const words = [
  "CAR MAINTENANCE",
  "BATTERY INSTALLATION",
  "LOCKOUT SERVICE",
  "TIRE CHANGES",
  "OIL CHANGES",
  "GAS DELIVERY",
];

export default function RibbonMarquee() {
  return (
    <div
      data-testid="ribbon-marquee"
      className="border-y border-white/10 bg-[#050505] py-8"
    >
      <Marquee speed={45} gradient={false} autoFill>
        {words.map((w, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display text-4xl md:text-6xl text-stroke px-8">
              {w}
            </span>
            <span className="text-primary text-3xl md:text-5xl">✦</span>
          </div>
        ))}
      </Marquee>
    </div>
  );
}
